import classNames from 'classnames'
import React, { PropsWithChildren, useContext, useEffect, useRef, useState } from 'react'
import { HeaderDataContext } from '../context/HeaderContext'
import { useBreakpoint } from '../hooks/useBreakpoint'
import { useWindowDimensions } from '../hooks/useWindowDimensions'
import { useWindowScroll } from '../hooks/useWindowScroll'
import { Breakpoints } from '../utilities/breakpoints'

export interface StickyItemProps {
  additionalClassName?: string
  additionalWrapperClassName?: string
  offsetBase?: number
  pageHasStickyMenu?: boolean
  skipOffset?: boolean
  stickyWrapperClassName?: string
  top?: string
}

export const StickyItem = ({
  additionalClassName,
  additionalWrapperClassName,
  children,
  offsetBase = 0,
  pageHasStickyMenu,
  skipOffset,
}: PropsWithChildren<StickyItemProps>) => {
  const [isSticky, setIsSticky] = useState(true)
  const scrollYPosition = useWindowScroll()
  const { screenHeight } = useWindowDimensions()
  const wrapperRef = useRef<HTMLDivElement>(null)
  const stickyItemRef = useRef<HTMLDivElement>(null)

  const headerHeight = useContext(HeaderDataContext)
  let top = headerHeight

  if (pageHasStickyMenu) {
    top += 75
  }

  const [aboveMobile, setAboveMobile] = useState<boolean>(false)
  useBreakpoint(Breakpoints.tb, setAboveMobile)

  useEffect(() => {
    if (!skipOffset && wrapperRef.current) {
      const wrapperPos = wrapperRef.current.offsetTop
      const offset = Math.floor(wrapperPos * 0.2 - scrollYPosition * 0.2)
      const offsetTop = aboveMobile ? offsetBase : 0

      wrapperRef.current.style.setProperty(
        'transform',
        `translate3d(0, ${Math.max(offset, offsetTop)}px, 0)`
      )
    }
  }, [aboveMobile, offsetBase, scrollYPosition, skipOffset])

  useEffect(() => {
    if (stickyItemRef.current) {
      setIsSticky(stickyItemRef.current.clientHeight < screenHeight)
    }
  }, [screenHeight])

  return (
    <div
      className={classNames(
        skipOffset ? 'flex-grow-0' : 'flex-grow',
        'tb:pb-75',
        'xl:pb-120',
        additionalWrapperClassName
      )}
      ref={wrapperRef}
    >
      <div
        className={classNames(
          { 'sticky': isSticky },
          'duration-200',
          additionalClassName
        )}
        ref={stickyItemRef}
        style={{
          top: `${top}px`,
        }}
      >
        {children}
      </div>
    </div>
  )
}
